import PropTypes from 'prop-types';
import React from 'react';

import i18n from 'scripts/i18n/i18n';
import NotificationContentContainer from './notification_content_container';
import TaskNotificationModel from 'models/notification/task_notification';

class TaskNotification extends React.Component {
  render() {
    const notification = this.props.notification;
    const content = notification.conversationItem.content.note;
    const heading = getHeading(notification);
    return (
      <NotificationContentContainer
        body={content}
        containerClasses="taskNotification"
        contentClasses="taskNotificationContent"
        heading={heading}
        iconClass="icon-task-filled"
        itemType="Task"
        notification={notification}
      />
    );
  }
}

function getHeading(notification) {
  return notification.conversationItem.content.hasNotifiedDue
    ? i18n.t('Assigned to you and due now')
    : i18n.t('Assigned to you');
}

TaskNotification.propTypes = {
  notification: PropTypes.oneOfType([PropTypes.instanceOf(TaskNotificationModel)]).isRequired,
};

export default TaskNotification;
